<template>

  <div class="elevation-4">
    <v-toolbar flat="flat">
      <v-toolbar-title>Icons</v-toolbar-title>
    </v-toolbar>
  </div>

</template>

<script>

export default {
  name: 'SportIcons',
  props: ['id']
}

</script>



// WEBPACK FOOTER //
// src/pages/sport/SportIcons.vue